export default __webpack_public_path__ + "f4821ed90f2b8173fee0100914b0f475.png";